export default "__VITE_ASSET__DVgwqgl5__"